var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternationalServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#10ACE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 2,
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.057 40.481c-.26 3.14.358 6.076 2.14 9.084l.01.017a.112.112 0 0 0 .011.018c1.78 3.007 4.056 4.961 6.936 6.242 1.257.56 2.124-.41 4.039-2.303.365-.362.323-.98-.088-1.317l-2.415-1.97a.84.84 0 0 0-1.19.1l-.258.317a.832.832 0 0 1-1.029.205l-.258-.131a4.908 4.908 0 0 1-1.66-1.383c-.33-.432-.683-.947-1.045-1.556l-.02-.035a15.844 15.844 0 0 1-.862-1.666 4.877 4.877 0 0 1-.415-2.12l.008-.288c.013-.4.29-.732.675-.804l.4-.075a.838.838 0 0 0 .66-.994l-.564-3.065c-.099-.522-.62-.857-1.114-.71-2.579.767-3.848 1.062-3.961 2.434zM42.785 29.766h14.337M28.449 29.766h11.053M42.785 44.454h14.337M28.449 44.454h11.053M46.088 37.11h12.804M26.675 37.11h16.108M42.783 21c-4.112 1.293-8.448 7.268-8.448 16.11M42.783 53.218c-4.112-1.293-8.448-7.268-8.448-16.108M42.783 21c4.113 1.293 8.449 7.268 8.449 16.11M42.783 53.218c4.113-1.293 8.449-7.268 8.449-16.108M42.783 53.218V21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.891 37.11c0 8.895-7.21 16.107-16.107 16.107-8.897 0-16.108-7.212-16.108-16.107 0-8.896 7.21-16.11 16.108-16.11 8.897 0 16.107 7.214 16.107 16.11z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalServices);
export default __webpack_public_path__ + "static/media/international-services.b210ee38c3d275100b1547ee02f58b95.svg";
export { ForwardRef as ReactComponent };